<template>
  <div :class="['service-item-landscape', 'round-corner', {'disabled': data.disabled}]" @click.stop="goDetail">
    <div class="service-content">
      <!-- <h3 class="item">
        <span>事项编号</span>
        <p class="service-name">{{ data.inventoryNumber?data.inventoryNumber:"暂无数据" }}</p>
      </h3> -->
      <div class="item">
        <span>事项名称：</span>
        <p>{{ data.inventoryName }}</p>
      </div>
      <div class="item">
        <span>所属部门：</span>
        <p>{{ data.organName }}</p>
      </div>
      <div class="item">
        <span>事项分类：</span>
        <p>{{ data.classifiedName }}</p>
      </div>
    </div>
  </div>
</template>

<script>
  import {fetchRgbColer} from '@/utils/commons'
  import {mapState} from "vuex"
  import {getThemeParams} from "@/utils/theme";
	export default {
		name: 'MatterItemLandscape',
    props: {
		  data: {
		    type: Object,
		    default: () => {
		      return {}
        }
      }
    },
		computed: {
      ...mapState(['matterObjects','matterNatures','matterModels','matterDepts']),
		  mainColor(){
        if (getThemeParams('main_color')){
          return getThemeParams('main_color');
        } else {
          return '#003c88'
        }
      },
      mainColorLight(){
        let rgb = fetchRgbColer(this.mainColor)
        return 'rgba('+rgb.join(',')+',0.08)'
      }
		},
		methods: {
      fetchRgbColer,
      getThemeParams,
      goDetail() {
        this.$emit('matterHandle', this.data)
      }
		},
		mounted() {
		}
	}
</script>

<style scoped lang="scss">
@import "~@/assets/css/theme/theme.scss";
  .service-item-landscape{
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: nowrap;
    padding:15px;
    margin-bottom:12px;
    border-radius:5px;
    background: #ffffff;
    .service-content{
     
        .item{
          display: flex;
          font-size: 0;
          span{
            display: block;
            margin-top: 4px;
            font-size: 15px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #555555;
            flex-shrink: 0;
            margin-right: 10px;
          }

          p{
            color: #888888;
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #888888;
            line-height: 22px;
          }
        }
      
      
    }
  }
</style>
